// Mobile drawer: one submenu open at a time (capture phase — toggle doesn't bubble)
document.addEventListener(
  "toggle",
  (e) => {
    const details = e.target;
    if (!details.matches(".menu-drawer details") || !details.open) {
      return;
    }
    const parentList = details.closest("li")?.parentElement;
    if (!parentList) {
      return;
    }
    parentList
      .querySelectorAll(":scope > li > details[open]")
      .forEach((sibling) => {
        if (sibling !== details) {
          sibling.removeAttribute("open");
        }
      });
  },
  true,
);

// Footer: accordion menus, one open at a time (mobile only)
const footerAccordionToggles = document.querySelectorAll(
  ".footer-accordion-toggle",
);

function toggleFooterAccordion(toggle) {
  if (window.innerWidth >= 990) {
    return;
  }

  const expanded = toggle.getAttribute("aria-expanded") === "true";
  const content = toggle.nextElementSibling;

  footerAccordionToggles.forEach((other) => {
    if (other === toggle) {
      return;
    }
    other.setAttribute("aria-expanded", "false");
    other.classList.remove("is-open");
    if (other.nextElementSibling) {
      other.nextElementSibling.style.maxHeight = "0px";
    }
  });

  if (expanded) {
    toggle.setAttribute("aria-expanded", "false");
    toggle.classList.remove("is-open");
    content.style.maxHeight = "0px";
  } else {
    toggle.setAttribute("aria-expanded", "true");
    toggle.classList.add("is-open");
    content.style.maxHeight = `${content.scrollHeight}px`;
  }
}

footerAccordionToggles.forEach((toggle) => {
  toggle.addEventListener("click", function (event) {
    // A merchant can embed a link inside the heading (rich text) — let it
    // navigate normally instead of also toggling the accordion.
    if (event.target.closest("a")) {
      return;
    }
    toggleFooterAccordion(this);
  });

  // Native <button> toggles get Enter/Space for free; the contact block's
  // toggle is a div[role=button] (so an embedded <a> in the heading can
  // legally nest inside it) and needs it wired up explicitly.
  if (toggle.getAttribute("role") === "button") {
    toggle.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      if (event.target.closest("a")) {
        return;
      }
      event.preventDefault();
      toggleFooterAccordion(this);
    });
  }
});

// Mobile header: menu drawer, search modal and cart drawer are mutually exclusive
const headerMenuToggle = document.querySelector(
  "header-drawer > details > summary",
);
const headerSearchToggle = document.querySelector(
  ".header__search > details > summary",
);
const cartIconLink = document.querySelector("#cart-icon-bubble");
const cartDrawerEl = document.querySelector("cart-drawer");

if (headerMenuToggle && headerSearchToggle) {
  const hardCloseMenuDrawer = () => {
    const details = headerMenuToggle.closest("details");
    if (!details.hasAttribute("open")) {
      return;
    }
    const drawerEl = headerMenuToggle.closest("header-drawer");
    details.classList.remove("menu-opening");
    details.querySelectorAll(".submenu-open").forEach((el) => {
      el.classList.remove("submenu-open");
    });
    details.querySelectorAll("details[open]").forEach((nested) => {
      nested.removeAttribute("open");
      nested.classList.remove("menu-opening");
    });
    details.removeAttribute("open");
    if (drawerEl) {
      document.body.classList.remove(
        `overflow-hidden-${drawerEl.dataset.breakpoint}`,
      );
    }
    removeTrapFocus();
  };

  const hardCloseSearchModal = () => {
    const details = headerSearchToggle.closest("details");
    if (!details.hasAttribute("open")) {
      return;
    }
    details.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus();
  };

  const hardCloseCartDrawer = () => {
    if (!cartDrawerEl || !cartDrawerEl.classList.contains("active")) {
      return;
    }
    cartDrawerEl.classList.remove("active", "animate");
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus();
  };

  headerMenuToggle.addEventListener(
    "click",
    () => {
      if (!headerMenuToggle.closest("details").hasAttribute("open")) {
        hardCloseSearchModal();
        hardCloseCartDrawer();
      }
    },
    true,
  );

  headerSearchToggle.addEventListener(
    "click",
    () => {
      if (!headerSearchToggle.closest("details").hasAttribute("open")) {
        hardCloseMenuDrawer();
        hardCloseCartDrawer();
      }
    },
    true,
  );

  if (cartIconLink) {
    cartIconLink.addEventListener(
      "click",
      () => {
        hardCloseMenuDrawer();
        hardCloseSearchModal();
      },
      true,
    );
  }
}

// header menu hover
const headerMenuDetails = Array.from(
  document.querySelectorAll("header-menu details"),
);
headerMenuDetails.forEach((details) => {
  let closeTimer;

  details.addEventListener("mouseenter", () => {
    clearTimeout(closeTimer);
    // Close all other open header menus immediately to prevent flash
    headerMenuDetails.forEach((other) => {
      if (other !== details) {
        other.removeAttribute("open");
      }
    });
    details.setAttribute("open", "");
  });

  details.addEventListener("mouseleave", () => {
    closeTimer = setTimeout(() => {
      details.removeAttribute("open");
    }, 250);
  });
});
// (function () {
//   const path = window.location.pathname;

//   if (path !== "/") {
//     window.location.replace("/");
//   }
// })();

// // header menu hover
// document.querySelectorAll("header-menu details").forEach((details) => {
//   details.addEventListener("mouseenter", () => {
//     details.setAttribute("open", "");
//   });

//   details.addEventListener("mouseleave", () => {
//     details.removeAttribute("open");
//   });

// });

/* ===== custom-swiper-slider ===== */
if (!customElements.get("custom-swiper-slider")) {
  customElements.define(
    "custom-swiper-slider",
    class extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector(".swiper");
        this.init();
        if (window.Shopify && Shopify.designMode) {
          this.onSelect = () => this.swiper?.autoplay?.stop();
          this.onDeselect = () => this.swiper?.autoplay?.start();
          this.addEventListener("shopify:section:select", this.onSelect);
          this.addEventListener("shopify:section:deselect", this.onDeselect);
        }
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.removeEventListener("shopify:section:select", this.onSelect);
        this.removeEventListener("shopify:section:deselect", this.onDeselect);
      }

      init() {
        if (typeof Swiper === "undefined" || !this.swiperEl) {
          return;
        }
        const configTag = this.querySelector("script[data-swiper-config]");
        let config;
        try {
          config = JSON.parse(configTag ? configTag.textContent : "{}");
        } catch (error) {
          config = {};
        }
        const nextEl = this.querySelector(".swiper-button-next");
        const prevEl = this.querySelector(".swiper-button-prev");
        const paginationEl = this.querySelector(".swiper-pagination");
        if (nextEl && prevEl) {
          config.navigation = Object.assign({}, config.navigation, {
            nextEl,
            prevEl,
          });
        }
        if (paginationEl && config.pagination) {
          config.pagination = Object.assign(
            { el: paginationEl },
            config.pagination,
          );
        }
        config.a11y = Object.assign({ enabled: true }, config.a11y);
        config.keyboard = Object.assign({ enabled: true }, config.keyboard);
        if (
          config.autoplay &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
          delete config.autoplay;
        }
        this.swiper = new Swiper(this.swiperEl, config);
      }
    },
  );
}

/* ===== product-gallery-swiper: swipeable PDP main image, synced with thumbnails ===== */
// if (!customElements.get("product-gallery-swiper")) {
//   customElements.define(
//     "product-gallery-swiper",
//     class extends HTMLElement {
//       connectedCallback() {
//         this.wrapperEl = this.querySelector(".swiper-wrapper");
//         if (!this.wrapperEl || typeof Swiper === "undefined") {
//           return;
//         }

//         this.prevButton = this.querySelector(".slider-button--prev");
//         this.nextButton = this.querySelector(".slider-button--next");
//         this.currentPageEl = this.querySelector(".slider-counter--current");
//         this.pageTotalEl = this.querySelector(".slider-counter--total");
//         this.syncing = false;

//         this.swiper = new Swiper(this, {
//           slidesPerView: 1,
//           spaceBetween: 0,
//           speed: 400,
//           grabCursor: true,
//           autoHeight: true,
//           observer: true,
//           observeParents: true,
//           a11y: { enabled: true },
//           keyboard: { enabled: true },
//           navigation:
//             this.prevButton && this.nextButton
//               ? { prevEl: this.prevButton, nextEl: this.nextButton }
//               : undefined,
//           on: {
//             slideChange: (swiper) => this.onSlideChange(swiper),
//           },
//         });

//         this.onSlideChange(this.swiper);

//         this.mutationObserver = new MutationObserver(
//           this.onMediaMutation.bind(this),
//         );
//         this.mutationObserver.observe(this.wrapperEl, {
//           childList: true,
//           attributes: true,
//           attributeFilter: ["class"],
//           subtree: true,
//         });
//       }

//       disconnectedCallback() {
//         this.mutationObserver?.disconnect();
//         this.swiper?.destroy(true, true);
//       }

//       onSlideChange(swiper) {
//         const activeSlide = swiper.slides[swiper.activeIndex];
//         if (!activeSlide) {
//           return;
//         }

//         this.syncing = true;
//         swiper.slides.forEach((slide) => slide.classList.remove("is-active"));
//         activeSlide.classList.add("is-active");
//         this.syncing = false;

//         this.updateNavState(swiper);

//         this.dispatchEvent(
//           new CustomEvent("slideChanged", {
//             detail: {
//               currentPage: swiper.activeIndex + 1,
//               currentElement: activeSlide,
//             },
//           }),
//         );
//       }

//       onMediaMutation(mutations) {
//         if (this.syncing || !this.swiper) {
//           return;
//         }

//         const shouldResync = mutations.some(
//           (mutation) =>
//             mutation.type === "childList" ||
//             (mutation.type === "attributes" &&
//               mutation.target.classList?.contains("is-active")),
//         );
//         if (!shouldResync) {
//           return;
//         }

//         this.swiper.update();
//         const activeIndex = this.swiper.slides.findIndex((slide) =>
//           slide.classList.contains("is-active"),
//         );
//         if (activeIndex > -1 && activeIndex !== this.swiper.activeIndex) {
//           this.swiper.slideTo(activeIndex, 0);
//         }
//         this.updateNavState(this.swiper);
//       }

//       updateNavState(swiper) {
//         if (this.currentPageEl) {
//           this.currentPageEl.textContent = swiper.activeIndex + 1;
//         }
//         if (this.pageTotalEl) {
//           this.pageTotalEl.textContent = swiper.slides.length;
//         }
//         if (this.prevButton) {
//           this.prevButton.disabled = swiper.isBeginning;
//         }
//         if (this.nextButton) {
//           this.nextButton.disabled = swiper.isEnd;
//         }
//       }
//     },
//   );
// }

// /* ===== product-gallery-thumbs-swiper: desktop thumbnail rail (5 visible), synced with main gallery ===== */
// if (!customElements.get("product-gallery-thumbs-swiper")) {
//   customElements.define(
//     "product-gallery-thumbs-swiper",
//     class extends HTMLElement {
//       connectedCallback() {
//         this.wrapperEl = this.querySelector("ul");
//         if (!this.wrapperEl || typeof Swiper === "undefined") {
//           return;
//         }

//         this.slideEls = Array.from(this.wrapperEl.children);
//         this.mainViewer = document.getElementById(this.dataset.mainViewerId);
//         this.prevButton = this.parentElement?.querySelector(
//           ".slider-button--prev",
//         );
//         this.nextButton = this.parentElement?.querySelector(
//           ".slider-button--next",
//         );
//         this.mql = window.matchMedia("(min-width: 990px)");
//         this.onBreakpointChange = () => this.reinit();
//         this.onMainSlideChanged = (event) =>
//           this.syncToMain(event.detail.currentElement);
//         this.onWindowLoad = () => this.swiper?.update();

//         this.mql.addEventListener("change", this.onBreakpointChange);
//         this.mainViewer?.addEventListener(
//           "slideChanged",
//           this.onMainSlideChanged,
//         );
//         window.addEventListener("load", this.onWindowLoad, { once: true });
//         document.fonts?.ready?.then(() => this.swiper?.update());

//         this.mutationObserver = new MutationObserver(
//           this.onThumbMutation.bind(this),
//         );
//         this.mutationObserver.observe(this.wrapperEl, {
//           attributes: true,
//           attributeFilter: ["aria-current"],
//           subtree: true,
//         });

//         this.reinit();
//       }

//       disconnectedCallback() {
//         this.mql.removeEventListener("change", this.onBreakpointChange);
//         this.mainViewer?.removeEventListener(
//           "slideChanged",
//           this.onMainSlideChanged,
//         );
//         window.removeEventListener("load", this.onWindowLoad);
//         this.mutationObserver?.disconnect();
//         this.teardownSwiper();
//       }

//       teardownSwiper() {
//         this.swiper?.destroy(true, true);
//         this.swiper = null;
//         this.classList.remove("swiper");
//         this.wrapperEl.classList.remove("swiper-wrapper");
//         this.slideEls.forEach((slide) =>
//           slide.classList.remove("swiper-slide"),
//         );
//       }

//       reinit() {
//         this.teardownSwiper();

//         if (!this.mql.matches) {
//           return;
//         }

//         this.classList.add("swiper");
//         this.wrapperEl.classList.add("swiper-wrapper");
//         this.slideEls.forEach((slide) => slide.classList.add("swiper-slide"));

//         this.swiper = new Swiper(this, {
//           direction: "vertical",
//           slidesPerView: 5,
//           spaceBetween: 10,
//           observer: true,
//           observeParents: true,
//           grabCursor: true,
//           mousewheel: { forceToAxis: true, releaseOnEdges: true },
//           a11y: { enabled: true },
//           keyboard: { enabled: true },
//           navigation:
//             this.prevButton && this.nextButton
//               ? { prevEl: this.prevButton, nextEl: this.nextButton }
//               : undefined,
//         });

//         this.syncActiveIntoView();
//       }

//       syncToMain(activeSlide) {
//         if (!activeSlide || !this.swiper) {
//           return;
//         }
//         const mediaId = activeSlide.dataset.mediaId;
//         const index = this.slideEls.findIndex(
//           (slide) => slide.dataset.target === mediaId,
//         );
//         if (index > -1) {
//           this.swiper.slideTo(index);
//         }
//       }

//       onThumbMutation(mutations) {
//         const changed = mutations.some(
//           (mutation) => mutation.attributeName === "aria-current",
//         );
//         if (changed) {
//           this.syncActiveIntoView();
//         }
//       }

//       syncActiveIntoView() {
//         if (!this.swiper) {
//           return;
//         }
//         const activeIndex = this.slideEls.findIndex((slide) =>
//           slide.querySelector("button")?.hasAttribute("aria-current"),
//         );
//         if (activeIndex > -1) {
//           this.swiper.slideTo(activeIndex);
//         }
//       }
//     },
//   );
// }

/* ===== custom-logo-marquee ===== */
if (!customElements.get("custom-logo-marquee")) {
  customElements.define(
    "custom-logo-marquee",
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector(".marquee__track");
        if (!this.track || !this.track.children.length) {
          return;
        }
        this.originalItems = Array.from(this.track.children);
        this.pauseOnHover = this.dataset.pauseHover === "true";
        this.onMouseEnter = () => this.track.classList.add("is-paused");
        this.onMouseLeave = () => this.track.classList.remove("is-paused");
        this.onResize = debounce(() => this.build(), 200);
        this.onReducedMotionChange = () => this.build();
        this.reducedMotionQuery = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        );
        window.addEventListener("resize", this.onResize);
        this.reducedMotionQuery.addEventListener(
          "change",
          this.onReducedMotionChange,
        );
        if (this.pauseOnHover) {
          this.addEventListener("mouseenter", this.onMouseEnter);
          this.addEventListener("mouseleave", this.onMouseLeave);
        }
        this.build();
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.onResize);
        this.reducedMotionQuery?.removeEventListener(
          "change",
          this.onReducedMotionChange,
        );
        if (this.pauseOnHover) {
          this.removeEventListener("mouseenter", this.onMouseEnter);
          this.removeEventListener("mouseleave", this.onMouseLeave);
        }
      }

      build() {
        this.track
          .querySelectorAll("[data-lm-clone]")
          .forEach((clone) => clone.remove());
        this.track.style.width = "";
        this.track.classList.remove("is-animating");

        if (this.reducedMotionQuery.matches) {
          return;
        }

        const images = this.originalItems.flatMap((item) =>
          Array.from(item.querySelectorAll("img")),
        );
        const ready = images.map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.addEventListener("load", resolve, { once: true });
                img.addEventListener("error", resolve, { once: true });
              }),
        );

        Promise.all(ready).then(() => this.fill());
      }

      fill() {
        const containerWidth = this.offsetWidth;
        const originalSetWidth = this.track.getBoundingClientRect().width;
        let setWidth = originalSetWidth;
        if (!setWidth || !containerWidth) {
          return;
        }

        let guard = 0;
        while (setWidth < containerWidth && guard < 50) {
          this.appendClone(this.originalItems);
          setWidth = this.track.getBoundingClientRect().width;
          guard += 1;
        }

        const fillWidth = setWidth;
        const filledSet = Array.from(this.track.children);
        this.appendClone(filledSet);
        this.track.style.width = `${fillWidth * 2}px`;

        const baseDuration =
          parseFloat(
            getComputedStyle(this).getPropertyValue("--lm-duration"),
          ) || 30;
        const scaledDuration = baseDuration * (fillWidth / originalSetWidth);
        this.track.style.setProperty("--lm-duration", `${scaledDuration}s`);

        this.track.classList.add("is-animating");
      }

      appendClone(items) {
        items.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          clone.setAttribute("data-lm-clone", "true");
          clone.removeAttribute("id");
          this.track.appendChild(clone);
        });
      }
    },
  );
}

// ── FAQ: smooth accordion, one open at a time ──
(() => {
  const faqAnimOpen = (details, answer) => {
    details.setAttribute("open", "");
    const h = answer.scrollHeight;
    answer.style.overflow = "hidden";
    answer.style.height = "0px";
    answer.style.transition = "";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        answer.style.transition = "height 0.3s ease";
        answer.style.height = `${h}px`;
        answer.addEventListener(
          "transitionend",
          () => {
            answer.style.height = "auto";
            answer.style.overflow = "";
            answer.style.transition = "";
          },
          { once: true },
        );
      });
    });
  };

  const faqAnimClose = (details, answer) => {
    if (!answer) {
      details.removeAttribute("open");
      return;
    }
    answer.style.height = `${answer.scrollHeight}px`;
    answer.style.overflow = "hidden";
    answer.style.transition = "";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        answer.style.transition = "height 0.3s ease";
        answer.style.height = "0px";
        answer.addEventListener(
          "transitionend",
          () => {
            details.removeAttribute("open");
            answer.style.height = "";
            answer.style.overflow = "";
            answer.style.transition = "";
          },
          { once: true },
        );
      });
    });
  };

  document.addEventListener("click", (e) => {
    const summary = e.target.closest(".cfaq-layout summary");
    if (!summary) {
      return;
    }
    e.preventDefault();
    const details = summary.closest("details");
    const answer = details.querySelector(".cfaq-answer");
    const layout = details.closest(".cfaq-layout");

    if (details.open) {
      faqAnimClose(details, answer);
    } else {
      layout
        ?.querySelectorAll("details[open]")
        .forEach((d) => faqAnimClose(d, d.querySelector(".cfaq-answer")));
      faqAnimOpen(details, answer);
    }
  });
})();

// ── PDP details accordion: smooth transition, one open at a time ──
(() => {
  const pdaAnimOpen = (details, content) => {
    details.setAttribute("open", "");
    const h = content.scrollHeight;
    content.style.overflow = "hidden";
    content.style.height = "0px";
    content.style.transition = "";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.transition = "height 0.3s ease";
        content.style.height = `${h}px`;
        content.addEventListener(
          "transitionend",
          () => {
            content.style.height = "auto";
            content.style.overflow = "";
            content.style.transition = "";
          },
          { once: true },
        );
      });
    });
  };

  const pdaAnimClose = (details, content) => {
    if (!content) {
      details.removeAttribute("open");
      return;
    }
    content.style.height = `${content.scrollHeight}px`;
    content.style.overflow = "hidden";
    content.style.transition = "";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.transition = "height 0.3s ease";
        content.style.height = "0px";
        content.addEventListener(
          "transitionend",
          () => {
            details.removeAttribute("open");
            content.style.height = "";
            content.style.overflow = "";
            content.style.transition = "";
          },
          { once: true },
        );
      });
    });
  };

  document.addEventListener("click", (e) => {
    const summary = e.target.closest(
      ".product-details-accordion__item > details > summary",
    );
    if (!summary) {
      return;
    }
    e.preventDefault();
    const details = summary.closest("details");
    const content = details.querySelector(":scope > .accordion__content");
    const group = details.closest(".product-details-accordion");

    if (details.open) {
      pdaAnimClose(details, content);
    } else {
      const detailsTop = details.getBoundingClientRect().top;
      group
        ?.querySelectorAll(".product-details-accordion__item > details[open]")
        .forEach((d) => {
          const dContent = d.querySelector(":scope > .accordion__content");
          // The first item is open by default (see sections/main-product.liquid),
          // so opening any OTHER item for the first time also closes that
          // first item, collapsing real content ABOVE the tapped one.
          // scrollY stays put while the page shrinks above it, dragging the
          // tapped tray up and out of view — worse the closer it is to the
          // bottom, since there's nothing below to reveal instead. A sibling
          // BELOW the tapped item doesn't affect its position, so only
          // above-siblings need this: close them instantly (no transition)
          // and shrink scrollY by the exact same amount in the same tick, so
          // the tapped tray never visibly moves — an animated close here
          // would still show a brief "drifts up, then corrects" wobble.
          const dRect = d.getBoundingClientRect();
          if (dRect.top < detailsTop) {
            const closingHeight = dContent ? dContent.scrollHeight : 0;
            d.removeAttribute("open");
            if (closingHeight > 0) {
              // css/base.css forces `html,body{scroll-behavior:smooth!important}`
              // (Tailwind's scroll-smooth! utility), so a plain scrollBy here
              // would animate over ~250ms instead of applying immediately —
              // exactly the "opens top, then corrects to bottom" wobble this
              // fix exists to remove. A NORMAL inline style loses to that
              // external !important (important-author beats normal-author,
              // and inline is normal-author) — it must be set with
              // setProperty(..., "important") to actually win, then removed
              // to restore the stylesheet's smooth behavior for everything
              // else (nav anchors, etc).
              document.documentElement.style.setProperty(
                "scroll-behavior",
                "auto",
                "important",
              );
              window.scrollBy(0, -closingHeight);
              document.documentElement.style.removeProperty("scroll-behavior");
            }
          } else {
            pdaAnimClose(d, dContent);
          }
        });
      pdaAnimOpen(details, content);
    }
  });
})();

// ── PDP FAQ accordion: same token-based technique as custom-mca-accordion ──
// (mid-transition-safe height read + double-rAF, one open at a time). Also
// prevents the right-side image jump when a section wraps this list in a
// flex row with items-stretch: the height change is a single smooth JS
// transition, never fought by a native ::details-content animation (see the
// ::details-content transition:none reset in custom-product-faq.liquid).
if (!customElements.get("custom-pfaq-accordion")) {
  customElements.define(
    "custom-pfaq-accordion",
    class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll(".pfaq-item"));
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.items.forEach((item) => {
          const summary = item.querySelector(".pfaq-item__summary");
          summary?.addEventListener("click", this.onSummaryClick);
        });
      }

      disconnectedCallback() {
        this.items.forEach((item) => {
          const summary = item.querySelector(".pfaq-item__summary");
          summary?.removeEventListener("click", this.onSummaryClick);
        });
      }

      get reducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }

      onSummaryClick(event) {
        event.preventDefault();
        const item = event.currentTarget.closest(".pfaq-item");
        if (!item) {
          return;
        }

        const willOpen = !item.hasAttribute("open");
        this.items
          .filter((other) => other !== item && other.hasAttribute("open"))
          .forEach((other) => this.setOpen(other, false));

        this.setOpen(item, willOpen);
      }

      setOpen(item, shouldOpen) {
        const content = item.querySelector(".pfaq-item__content");
        if (!content) {
          return;
        }

        const isOpen = item.hasAttribute("open");
        if (shouldOpen === isOpen && item.pfaqToken === undefined) {
          return;
        }

        const token = (item.pfaqToken = (item.pfaqToken || 0) + 1);
        const startHeight = content.getBoundingClientRect().height;
        content.style.transition = "";

        if (this.reducedMotion) {
          if (shouldOpen) {
            item.setAttribute("open", "");
          } else {
            item.removeAttribute("open");
          }
          content.style.height = "";
          content.style.overflow = "";
          return;
        }

        if (shouldOpen) {
          item.setAttribute("open", "");
        }

        content.style.overflow = "hidden";
        content.style.height = `${startHeight}px`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (item.pfaqToken !== token) {
              return;
            }
            const endHeight = shouldOpen ? content.scrollHeight : 0;
            content.style.transition = "height 0.3s ease";
            content.style.height = `${endHeight}px`;
            content.addEventListener(
              "transitionend",
              (event) => {
                if (
                  event.propertyName !== "height" ||
                  item.pfaqToken !== token
                ) {
                  return;
                }
                if (!shouldOpen) {
                  item.removeAttribute("open");
                }
                content.style.height = "";
                content.style.overflow = "";
                content.style.transition = "";
              },
              { once: true },
            );
          });
        });
      }
    },
  );
}

// ── Cart Upsell: ATC ──
(() => {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".cu-add-btn");
    if (!btn) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) {
      return;
    }

    const row = btn.closest(".cu-row");
    btn.classList.add("is-loading");
    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((r) => {
        if (!r.ok) {
          throw new Error("add failed");
        }
        return r.json();
      })
      .then(() => {
        // Optimistic: remove row immediately
        if (row) {
          row.remove();
        }

        // Hide upsell block if no rows remain
        const upsell = document.getElementById("CartUpsell");
        if (upsell && !upsell.querySelector(".cu-row")) {
          upsell.remove();
        }

        // Trigger Dawn's cart re-render for totals + header count
        if (
          typeof publish !== "undefined" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-upsell",
            productVariantId: variantId,
          });
        }
      })
      .catch(() => {
        btn.classList.remove("is-loading");
        btn.disabled = false;
      });
  });
})();

// ── Cart Shipping Bar: update text on cart change ──
(() => {
  function updateShippingBar(totalPriceCents) {
    const bar = document.getElementById("CartShippingBar");
    if (!bar) {
      return;
    }
    const threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (!threshold) {
      return;
    }
    const remaining = threshold - totalPriceCents;
    const p = bar.querySelector("p");
    if (!p) {
      return;
    }
    if (remaining > 0) {
      const dollars = Math.ceil(remaining / 100);
      const msg = (bar.dataset.message || "").replace(
        "[amount]",
        `$${dollars}`,
      );
      p.textContent = msg;
    } else {
      p.textContent = bar.dataset.complete || "";
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (
      typeof subscribe === "undefined" ||
      typeof PUB_SUB_EVENTS === "undefined"
    ) {
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => updateShippingBar(cart.total_price))
        .catch(() => {});
    });
  });
})();

// ── PDP quantity selector: stop change event from bubbling past <quantity-input> ──
// The +/- buttons fire a change event on the number input. Third-party app scripts
// (e.g. Seal Subscriptions) may catch it on a higher ancestor and treat it as a
// variant-option change, triggering an optionValueSelectionChange re-render of
// <variant-selects> with the wrong (default) variant selected. Stopping the event
// at the <quantity-input> boundary is safe: Dawn's price-per-item.js and
// QuantityInput listeners both bind directly to the input element, not ancestors.
// See error log: variant re-render on quantity change, Duo discount badge disappears.
(() => {
  function guardQuantityInput(qi) {
    if (qi._quantityChangeStopped) {
      return;
    }
    qi._quantityChangeStopped = true;
    qi.addEventListener("change", (e) => {
      if (e.target.type === "number") {
        e.stopPropagation();
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document
        .querySelectorAll(".ctm-quantity-selector")
        .forEach(guardQuantityInput);
    });
  } else {
    document
      .querySelectorAll(".ctm-quantity-selector")
      .forEach(guardQuantityInput);
  }
})();

// ── Cart Drawer: keep --ctm-header-height in sync so the drawer stays
//    anchored to the header's actual bottom edge (sticky/announcement-bar/
//    breakpoint agnostic) ──
(() => {
  const header = document.querySelector(".ctm-header");
  if (!header) {
    return;
  }

  const root = document.documentElement;
  const setHeaderHeight = () => {
    const bottom = Math.ceil(header.getBoundingClientRect().bottom);
    root.style.setProperty("--ctm-header-height", `${Math.max(bottom, 0)}px`);
  };

  setHeaderHeight();

  const onRecalc =
    typeof debounce === "function"
      ? debounce(setHeaderHeight, 100)
      : setHeaderHeight;
  window.addEventListener("resize", onRecalc);
  window.addEventListener("scroll", onRecalc, { passive: true });

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(setHeaderHeight);
    observer.observe(header);
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target.querySelector(".ctm-header")) {
      setHeaderHeight();
    }
  });
})();

// ── Header nav: mark parent link active when a child dropdown link is current ──
(() => {
  document
    .querySelectorAll(
      '.header__submenu [aria-current="page"], .mega-menu__content [aria-current="page"]',
    )
    .forEach((activeChild) => {
      const parentLink = activeChild
        .closest("details")
        ?.querySelector(".header__menu-item-link");
      if (!parentLink) {
        return;
      }
      parentLink.classList.add("header__active-menu-item");
      const span = parentLink.querySelector("span");
      if (span) {
        span.classList.add("header__active-menu-item");
      }
    });
})();

/* ===== clinical-study-tabs (Clinical Study page: product tab switcher / mobile dropdown) ===== */
if (!customElements.get("clinical-study-tabs")) {
  customElements.define(
    "clinical-study-tabs",
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) {
          return;
        }

        this.list = this.querySelector(".cs-tabs-list");

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) {
            this.closeList();
          }
        };
        this.onDocumentKeydown = (event) => {
          if (event.key === "Escape") {
            this.closeList();
          }
        };
        document.addEventListener("click", this.onDocumentClick);
        document.addEventListener("keydown", this.onDocumentKeydown);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener("click", () => this.onTabClick(tab, index));
          tab.addEventListener("keydown", (event) =>
            this.onKeydown(event, index),
          );
        });
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.onDocumentClick);
        document.removeEventListener("keydown", this.onDocumentKeydown);
      }

      onTabClick(tab, index) {
        if (tab.getAttribute("aria-selected") === "true") {
          this.toggleList();
          return;
        }
        this.selectTab(index);
      }

      toggleList() {
        this.list?.classList.toggle("is-open");
      }

      closeList() {
        this.list?.classList.remove("is-open");
      }

      onKeydown(event, index) {
        const keyToIndex = {
          ArrowRight: (index + 1) % this.tabs.length,
          ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length,
          Home: 0,
          End: this.tabs.length - 1,
        };
        const nextIndex = keyToIndex[event.key];
        if (nextIndex !== undefined) {
          event.preventDefault();
          this.selectTab(nextIndex, true);
          return;
        }
        if (event.key === "Escape") {
          this.closeList();
        }
      }

      selectTab(index, focus) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute("aria-selected", selected ? "true" : "false");
          tab.tabIndex = selected ? 0 : -1;

          const panel = document.getElementById(
            tab.getAttribute("aria-controls"),
          );
          if (!panel) {
            return;
          }
          if (selected) {
            panel.removeAttribute("hidden");
            panel.style.display = "";
          } else {
            panel.setAttribute("hidden", "");
            panel.style.display = "none";
          }
        });

        this.closeList();
        if (focus) {
          this.tabs[index].focus();
        }
      }
    },
  );
}

// Clinical Study: make entire cs-card__info clickable to open its popup
(function () {
  document.querySelectorAll(".cs-card__info").forEach((cardInfo) => {
    if (cardInfo.querySelector("modal-opener > button")) {
      cardInfo.style.cursor = "pointer";
    }
  });

  document.addEventListener("click", (event) => {
    const cardInfo = event.target.closest(".cs-card__info");
    if (!cardInfo) {
      return;
    }
    if (event.target.closest("modal-opener, modal-dialog")) {
      return;
    }
    const btn = cardInfo.querySelector("modal-opener > button");
    if (btn) {
      btn.click();
    }
  });
})();

// Blog Hub: client-side article search (filters rendered articles instantly)
(function () {
  const input = document.getElementById("BhSearchInput");
  if (!input) {
    return;
  }

  const hero = document.querySelector(".bh-hero");
  const grid = document.getElementById("BhGrid");
  const noResults = document.getElementById("BhNoResults");
  const articles = grid
    ? Array.from(grid.querySelectorAll("article.bh-card"))
    : [];

  function reset() {
    if (hero) {
      hero.style.display = "";
    }
    articles.forEach((a) => {
      a.style.display = "";
    });
    if (noResults) {
      noResults.style.display = "none";
    }
  }

  input.addEventListener("input", () => {
    const q = input.value.trim().toLowerCase();

    if (!q) {
      reset();
      return;
    }

    if (hero) {
      const heroText = hero.dataset.search || "";
      const heroMatch = heroText.includes(q);
      hero.style.display = heroMatch ? "" : "none";
    }

    let matchCount = 0;
    articles.forEach((article, i) => {
      const text = article.dataset.search || "";
      const match = text.includes(q);
      article.style.display = match ? "" : "none";
      if (match) {
        matchCount++;
      }
    });

    if (noResults) {
      noResults.style.display =
        matchCount === 0 && (!hero || hero.style.display === "none")
          ? ""
          : "none";
    }
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      input.value = "";
      reset();
    }
  });
})();

/* ===== custom-medicine-cabinet ===== */
if (!customElements.get("custom-mca-accordion")) {
  customElements.define(
    "custom-mca-accordion",
    class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll(".mca-item"));
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.items.forEach((item) => {
          const summary = item.querySelector(".mca-item__summary");
          summary?.addEventListener("click", this.onSummaryClick);
        });

        // Desktop layout stretches the right-hand image to the height of
        // this copy column (align-items:stretch). Left unmanaged, that
        // stretch re-measures live off the column's height every time the
        // accordion animates open/closed, so the image visibly resizes
        // (and on Edge, snaps/jumps instead of tracking smoothly) on every
        // toggle. Fix: lock the image to a single fixed height, computed
        // once as the TALLEST height the column can ever reach (base rows
        // + the tallest single item's content) — so the image is always
        // tall enough for any item and never has to react to which item is
        // open. Recomputed only on breakpoint/viewport resize, never on
        // accordion click, so opening/closing has zero effect on it.
        this.wrap = this.closest(".mca-wrap");
        this.copy = this.closest(".mca-copy");
        this.media = this.wrap?.querySelector(".mca-media") || null;
        this.onResize = this.debounce(() => this.lockMediaHeight(), 150);
        window.addEventListener("resize", this.onResize);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.lockMediaHeight());
        });
      }

      disconnectedCallback() {
        this.items.forEach((item) => {
          const summary = item.querySelector(".mca-item__summary");
          summary?.removeEventListener("click", this.onSummaryClick);
        });
        window.removeEventListener("resize", this.onResize);
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn(...args), wait);
        };
      }

      // Measures every item's expanded content height by briefly forcing
      // `open` on whichever items are currently closed, reading the
      // rendered height, then reverting — all synchronously in one task
      // with no rAF/await in between, so the browser never paints the
      // momentary open state and nothing flickers.
      lockMediaHeight() {
        if (!this.media || !this.copy) {
          return;
        }
        if (window.innerWidth < 990) {
          this.media.style.height = "";
          return;
        }

        const openItem = this.items.find((item) => item.hasAttribute("open"));
        const openContent = openItem?.querySelector(".mca-item__content");
        const openContentHeight = openContent
          ? openContent.getBoundingClientRect().height
          : 0;
        const baseHeight =
          this.copy.getBoundingClientRect().height - openContentHeight;

        let maxContentHeight = openContentHeight;
        this.items.forEach((item) => {
          const content = item.querySelector(".mca-item__content");
          if (!content) {
            return;
          }
          const wasOpen = item.hasAttribute("open");
          if (!wasOpen) {
            item.setAttribute("open", "");
          }
          const height = content.getBoundingClientRect().height;
          if (height > maxContentHeight) {
            maxContentHeight = height;
          }
          if (!wasOpen) {
            item.removeAttribute("open");
          }
        });

        this.media.style.height = `${Math.ceil(baseHeight + maxContentHeight)}px`;
      }

      get reducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }

      onSummaryClick(event) {
        event.preventDefault();
        const item = event.currentTarget.closest(".mca-item");
        if (!item) {
          return;
        }

        const willOpen = !item.hasAttribute("open");
        this.items
          .filter((other) => other !== item && other.hasAttribute("open"))
          .forEach((other) => this.setOpen(other, false));

        this.setOpen(item, willOpen);
      }

      // Single state-setter for both directions, same double-rAF + CSS
      // transition technique already used by the other accordions in this
      // file (see pdaAnimOpen/pdaAnimClose above). Reads the CURRENT
      // rendered height (mid-transition if one is running) before touching
      // anything, so a rapid click that reverses direction hands off
      // smoothly instead of jumping — and the double rAF forces the browser
      // to commit that start height as a real frame before the transition
      // begins, which is what prevents the first frame from getting
      // coalesced away (the "jerk" a same-tick style+transition can cause).
      setOpen(item, shouldOpen) {
        const content = item.querySelector(".mca-item__content");
        if (!content) {
          return;
        }

        const isOpen = item.hasAttribute("open");
        if (shouldOpen === isOpen && item.mcaToken === undefined) {
          return;
        }

        const token = (item.mcaToken = (item.mcaToken || 0) + 1);
        const startHeight = content.getBoundingClientRect().height;
        content.style.transition = "";

        if (this.reducedMotion) {
          if (shouldOpen) {
            item.setAttribute("open", "");
          } else {
            item.removeAttribute("open");
          }
          content.style.height = "";
          content.style.overflow = "";
          return;
        }

        if (shouldOpen) {
          item.setAttribute("open", "");
        }

        content.style.overflow = "hidden";
        content.style.height = `${startHeight}px`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (item.mcaToken !== token) {
              return;
            }
            const endHeight = shouldOpen ? content.scrollHeight : 0;
            content.style.transition = "height 0.3s ease";
            content.style.height = `${endHeight}px`;
            content.addEventListener(
              "transitionend",
              (event) => {
                if (
                  event.propertyName !== "height" ||
                  item.mcaToken !== token
                ) {
                  return;
                }
                if (!shouldOpen) {
                  item.removeAttribute("open");
                }
                content.style.height = "";
                content.style.overflow = "";
                content.style.transition = "";
              },
              { once: true },
            );
          });
        });
      }
    },
  );
}

/* ===== card-variant-picker (collection card variant pill switcher) ===== */
if (!customElements.get("card-variant-picker")) {
  customElements.define(
    "card-variant-picker",
    class extends HTMLElement {
      connectedCallback() {
        this.scopeRoot = this.closest(".card-wrapper") || this;
        this.onPillClick = this.onPillClick.bind(this);
        this.addEventListener("click", this.onPillClick);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onPillClick);
      }

      onPillClick(event) {
        const pill = event.target.closest(".card-variant-picker__pill");
        if (!pill || !this.contains(pill)) {
          return;
        }
        event.preventDefault();
        this.selectVariant(pill);
      }

      selectVariant(pill) {
        this.querySelectorAll(".card-variant-picker__pill").forEach((btn) => {
          const isActive = btn === pill;
          btn.classList.toggle("card-variant-picker__pill--active", isActive);
          btn.setAttribute("aria-pressed", isActive ? "true" : "false");
        });

        const variantId = pill.dataset.variantId;
        const available = pill.dataset.available === "true";
        const isSale = pill.dataset.sale === "true";

        const priceTarget = this.scopeRoot.querySelector("[data-card-price]");
        if (priceTarget) {
          const priceEl = priceTarget.querySelector(".price");
          const container = priceTarget.querySelector(".price__container");
          if (container) {
            container.innerHTML = pill.dataset.priceHtml;
          }
          if (priceEl) {
            priceEl.classList.toggle("price--on-sale", isSale);
          }
        }

        const variantInput = this.scopeRoot.querySelector(
          ".product-variant-id",
        );
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.disabled = !available;
        }

        const submitButton = this.scopeRoot.querySelector(".quick-add__submit");
        if (submitButton) {
          submitButton.disabled = !available;
          const label = submitButton.querySelector(
            "span:not(.sold-out-message)",
          );
          if (label) {
            label.textContent = pill.dataset.addHtml;
          }
        }

        const baseUrl = this.dataset.cardUrl;
        if (baseUrl) {
          this.scopeRoot
            .querySelectorAll("a.full-unstyled-link[href]")
            .forEach((link) => {
              link.href = `${baseUrl}?variant=${variantId}`;
            });
        }
      }
    },
  );
}

// Article h4 indent: mark siblings between h4 and next h2/h3 with .h4-child
(function articleH4Indent() {
  const content = document.querySelector(
    ".article-template .article-template__content",
  );
  if (!content) {
    return;
  }
  content.querySelectorAll("h4").forEach((h4) => {
    let el = h4.nextElementSibling;
    while (el && !["H2", "H3", "H4"].includes(el.tagName)) {
      el.classList.add("h4-child");
      el = el.nextElementSibling;
    }
  });
})();
